module.exports = __webpack_public_path__ + "img/general-checked.4648ba38.svg";